import React from 'react';
import { useTranslation } from 'react-i18next';

import Header from '../../components/shared/Header/Header';

import PaymentsTabs from './PaymentsTabs/PaymentsTabs';

const Payments = ({ tab, subTab }) => {
  const { t } = useTranslation('common');
  return (
    <div className="d-flex flex-column flex-grow-1 h-[100vh] overflow-y-hidden max-md:h-[calc(100vh-50px)]">
      <Header title={t('payments.portal')} />
      <PaymentsTabs subTab={subTab} tab={tab} />
    </div>
  );
};

export default Payments;
